import React, { useState } from 'react'
import DayFilteringWidget from './student/DayFilteringWidget'
import { daysFilterList } from './class/ClassAnalyticsWidgets'

export default function CounsellorAnalyticsLayout({ header, title, card, daysFilter, setDaysFilter, children }) {
    const [showFilter, setShowFilter] = useState(false)

    return (
        <div id="studentAnalyticsId" className="page-shell flex flex-col flex-1 min-h-0 bg-lightBG overflow-y-auto">
            <div className="max-w-[1360px] mx-[auto] w-full ">
                {header}
                <div className="mt-[10px] flex flex-row items-center justify-between gap-[15px]">
                    <p className="page-title text-darkenPurple font-semibold truncate">{title}</p>
                    <div
                        className="transition-all duration-300 ease-in-out"
                        style={{
                            opacity: showFilter ? 1 : 0,
                            visibility: showFilter ? 'visible' : 'hidden',
                            transform: showFilter ? 'translateY(0)' : 'translateY(-10px)',
                            zIndex: 4,
                        }}
                    >
                        <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
                    </div>
                </div>
                <div className="w-full border-b border-b-white mt-5"></div>
                <div className="flex flex-row items-stretch xl:gap-6 transition-all " style={{ minHeight: 'max(685px, calc(100vh - 160px))' }}>
                    <div className="pt-[20px] w-auto min-h-full" data-tour="class-card">{card}</div>
                    <div className="flex-1 relative" data-tour="analytics-widgets" id="analytics-widgets">
                        <div className="absolute inset-0 overflow-y-auto" onScroll={(event) => setShowFilter(event.currentTarget.scrollTop > 100)}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
